




















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';
import {getListFacebookPixel} from '@/services/FacebookPixelService';
import {IFacebookPixel} from '@/models/IFacebookPixel';
import ProductView from '@/components/ProductView.vue';
import EnabledStatusLabel from '@/components/EnabledStatusLabel.vue';
import PageStatusLabel from '@/components/PageStatusLabel.vue';
import RemoveFacebookPixelBtn from '@/screens/dashboard/facebookpixel/RemoveFacebookPixelBtn.vue';
import ShopCollectionTag from '@/components/ShopCollectionTag.vue';

@Component({
  components: {EnabledStatusLabel, ProductView, PageStatusLabel, RemoveFacebookPixelBtn, ShopCollectionTag}
})
export default class FacebookPixelTable extends Vue {
  loading: boolean = true;
  facebookPixels: IFacebookPixel[] = [];

  headers: DataTableHeader[] = [
    {text: 'Facebook Pixel ID', value: 'facebook_pixel_id'},
    {text: 'Collections', value: 'shop_collections'},
    {text: 'Products', value: ''},
    {text: 'Enabled', value: 'enabled'},
    {text: 'Capi Enabled', value: 'capi_enabled'},
    {text: 'Capi Token', value: 'capi_token'},
    {text: 'Pages', value: ''},
    {text: 'Actions', value: ''},
  ];

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.facebookPixels = await getListFacebookPixel(this.organizationId, this.shopId);
    } finally {
      this.loading = false;
    }
  }

  goToFacebookPixelDetailScreen(id: number) {
    this.$router.push({name: 'dashboard.facebook-pixel.detail', params: {id: id.toString()}});
  }
}
